import React, { useRef } from "react";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useOutsideClick from "../../hooks/useOutsideClick";
import PersianPrice from "../Header/PersianPrice";
import PaymentIcon from "@material-ui/icons/Payment";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import DescriptionIcon from "@material-ui/icons/Description";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SmallBalance({ classes }) {
  const { t, i18n } = useTranslation();
  const wrapperBalanceRef = useRef(null);
  const [toggleDropdown, setToggleDropdown] =
    useOutsideClick(wrapperBalanceRef);

  function handleClickBalance() {
    setToggleDropdown(!toggleDropdown);
  }

  return (
    <ul
      className={
        i18n.language === "en"
          ? classes.menuItemContainerLtr
          : classes.menuItemContainer
      }
    >
      <li
        className={toggleDropdown ? classes.menuItemActive : classes.menuItem}
        onClick={handleClickBalance}
      >
        <span
          className={classes.profileTitle}
          style={{
            marginRight: 10,
            fontWeight: "bold",
            fontSize: 15,
          }}
        >
          <PersianPrice number={0} />
        </span>
        <span
          className={classes.profileTitle}
          style={{
            marginRight: 5,
            marginLeft: 10,
            fontSize: 10,
          }}
        >
          ریال
        </span>
        <span>
          {toggleDropdown ? (
            <ExpandLessIcon className={classes.icons} fontSize="small" />
          ) : (
            <ExpandMoreIcon className={classes.icons} fontSize="small" />
          )}
        </span>
      </li>
      {toggleDropdown && (
        <span ref={wrapperBalanceRef}>
          <li
            className={classes.dropdown}
            onClick={() => {
              // setOpen((prevVal) => !prevVal);
              handleClickBalance();
            }}
          >
            <span
              className={
                i18n.language === "en" ? classes.listItemLtr : classes.listItem
              }
              style={{ color: "#1d1c22" }}
            >
              <p>{t("header.charge_account")}</p>
              <AttachMoneyIcon style={{ fontSize: "20px", padding: 3 }} />
            </span>
          </li>

          <hr />
          <Link style={{ textDecoration: "none" }} to={"/app/invoice-page"}>
            <li className={classes.dropdown} onClick={handleClickBalance}>
              <span
                className={
                  i18n.language === "en"
                    ? classes.listItemLtr
                    : classes.listItem
                }
                style={{ color: "#1d1c22" }}
              >
                <p>{t("header.invoices")}</p>
                <DescriptionIcon style={{ fontSize: "20px", padding: 3 }} />
              </span>
            </li>
          </Link>
          <Link style={{ textDecoration: "none" }} to={"/app/transaction-page"}>
            <li className={classes.dropdown} onClick={handleClickBalance}>
              <span
                className={
                  i18n.language === "en"
                    ? classes.listItemLtr
                    : classes.listItem
                }
                style={{ color: "#1d1c22" }}
              >
                <p>{t("header.transactions")}</p>
                <PaymentIcon style={{ fontSize: "20px", padding: 3 }} />
              </span>
            </li>
          </Link>
        </span>
      )}
    </ul>
  );
}
